import Logo from '../../components/Logo';

/**
 * Terminal screens. Neither shows a score: results go to the recruiting team, and
 * the candidate's takeaway is the codename they need in order to ask about them.
 */

export function CompletedScreen({ codename }: { codename: string }) {
  return (
    <div className="mx-auto flex min-h-screen max-w-xl flex-col items-center justify-center p-6 text-center">
      <Logo size={32} className="mb-8 justify-center" />
      <h1 className="text-3xl font-semibold">Your answers have been submitted</h1>
      <p className="mt-4 text-sm text-ink/70">
        Thank you for taking the time. Your responses have been sent to the recruiting team for
        review.
      </p>

      <div className="mt-8 w-full rounded-md border-2 border-warn bg-warn/5 p-5">
        <p className="text-xs uppercase tracking-widest text-warn">Your codename</p>
        <p className="mt-2 font-mono text-2xl font-bold">{codename}</p>
        <p className="mt-3 text-sm text-ink/80">
          Write this down and share it with the recruiters. It is the only way for you to refer to
          your results, and it cannot be recovered later.
        </p>
      </div>

      <p className="mt-8 text-xs text-ink/50">
        You can close this tab. The link will not work again.
      </p>
    </div>
  );
}

export function ForfeitedScreen({ codename }: { codename: string | null }) {
  return (
    <div className="mx-auto flex min-h-screen max-w-xl flex-col items-center justify-center p-6 text-center">
      <h1 className="text-3xl font-semibold text-danger">This test has ended</h1>
      <p className="mt-4 text-sm text-ink/70">
        The session was closed before the test was completed, so it has been forfeited. As set out
        in the instructions, there is no way to resume and this link will not work again.
      </p>
      <p className="mt-3 text-sm text-ink/70">
        The recruiting team has been notified, along with the part of the test that was completed.
      </p>

      {codename ? (
        <div className="mt-8 w-full rounded-md border border-ink/15 bg-surface p-5">
          <p className="text-xs uppercase tracking-widest text-ink/50">Your codename</p>
          <p className="mt-2 font-mono text-xl font-bold">{codename}</p>
          <p className="mt-2 text-sm text-ink/70">
            Quote this if you want to discuss what happened with the recruiters.
          </p>
        </div>
      ) : null}
    </div>
  );
}

export function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <p className="text-sm text-ink/50">Loading…</p>
    </div>
  );
}
